import React from 'react';
import { CommonIconProps } from './Icon';

const Step1Icon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <rect width="24" height="24" rx="12" fill={color} />
    <path
      d="M13.438 8V16H11.7466V9.60547H11.6997L9.86768 10.7539V9.25391L11.8481 8H13.438Z"
      fill="white"
    />
  </>
);

export default Step1Icon;
